<template>
  <div class="register-container">
    <!-- 系统 Logo 与标题 -->
    <div class="logo-wrap">
      <img src="@/assets/owl_1.svg" alt="系统图标" class="logo-icon" />
      <h1 class="system-title">猫头鹰AI视光师助理</h1>
    </div>

    <!-- 注册卡片 -->
    <el-card class="register-card" shadow="hover">
      <div slot="header" class="card-header">
        <span>用户注册</span>
      </div>
      <el-form
        :model="form"
        :rules="rules"
        ref="formRef"
        label-width="100px"
        class="register-form"
      >
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
          />
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="form.password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
          />
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            type="password"
            v-model="form.confirmPassword"
            placeholder="请再次输入密码"
            prefix-icon="el-icon-lock"
            show-password
          />
        </el-form-item>

        <el-form-item label="门店" prop="store">
          <el-select
            v-model="form.store"
            placeholder="请选择门店"
            style="width: 100%"
          >
            <el-option label="庐阳区海棠店" value="庐阳区海棠店"></el-option>
            <el-option label="滨湖金融港店" value="滨湖金融港店"></el-option>
            <el-option label="经开店" value="经开店"></el-option>
            <el-option label="桐城路店" value="桐城路店"></el-option>
            <el-option label="肥东店" value="肥东店"></el-option>
            <el-option label="淮北店" value="淮北店"></el-option>
            <el-option label="宿州店" value="宿州店"></el-option>
            <el-option label="徽州店" value="徽州店"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="验光师" prop="optometrist">
          <el-input
            v-model="form.optometrist"
            placeholder="请输入验光师姓名"
            prefix-icon="el-icon-user"
          />
        </el-form-item>

        <el-form-item label="邀请码" prop="inviteCode">
          <el-input
            v-model="form.inviteCode"
            placeholder="请输入邀请码"
            prefix-icon="el-icon-key"
          />
        </el-form-item>

        <el-form-item class="btn-group">
          <el-button type="primary" @click="submitForm">注册</el-button>
          <el-button type="text" @click="goToLogin">去登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  name: 'RegisterView',
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      form: {
        username: '',
        password: '',
        confirmPassword: '',
        store: '',
        optometrist: '',
        inviteCode: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少 6 位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ],
        store: [
          { required: true, message: '请选择门店', trigger: 'change' }
        ],
        optometrist: [
          { required: true, message: '请输入验光师姓名', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return;

        // 使用 SHA-256 加密密码
        const encryptedPassword = CryptoJS.SHA256(this.form.password).toString();

        this.$http.post('/api/register/', {
          username: this.form.username,
          password: encryptedPassword,
          store: this.form.store,
          optometrist: this.form.optometrist,
          inviteCode: this.form.inviteCode
        })
        .then(() => {
          this.$message.success('注册成功');
          this.$router.push('/login');
        })
        .catch(err => {
          const msg = err.response?.data?.message || '注册失败';
          this.$message.error(msg);
        });
      });
    },
    goToLogin() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.register-container {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.8);
  padding: 12px 24px;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.logo-icon {
  width: 48px;
  height: 48px;
  margin-right: 12px;
}

.system-title {
  color: #0369a1;
  font-size: 1.8rem;
  font-weight: bold;
}

.register-card {
  width: 400px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #bae6fd;
  box-shadow: 0 8px 20px rgba(2, 132, 199, 0.15);
}

.card-header {
  font-size: 1.2rem;
  font-weight: 500;
  background: #f0f9ff;
  color: #0369a1;
  border-bottom: 1px solid #bae6fd;
}

.register-form {
  padding: 20px;
  background-color: #fff;
}

.register-form .el-form-item {
  margin-bottom: 18px;
}

/* 按钮组对齐输入框左侧 */
.btn-group {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  margin-top: 10px;
  margin-left: 100px; /* 与 label-width 对齐 */
}

.el-button--primary {
  background-color: #0284c7;
  border-color: #0284c7;
}

.el-button--primary:hover {
  background-color: #0369a1;
  border-color: #0369a1;
}
</style>
